// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-track-box .wm-base-box-container {
  overflow: hidden;
  width: 225px;
  height: 185px;
  border-radius: 15px;
  margin: 0;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
}
wm-track-box .wm-base-box-container .wm-base-box-image-container {
  display: block;
  height: 49.95%;
  background-color: var(--wm-color-skeleton);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
wm-track-box .wm-base-box-container .wm-base-box-header {
  padding: 0 15px;
  text-align: left;
}
wm-track-box .wm-base-box-container .wm-base-box-header .wm-base-box-subtitle {
  text-align: left;
  color: var(--wm-color-primary);
  text-transform: uppercase;
  margin: 0;
  padding: 15px 0 0;
  font-size: var(--wm-font-xsm);
  font-weight: var(--wm-font-weight-light);
}
wm-track-box .wm-base-box-container .wm-base-box-header .wm-base-box-title {
  text-align: left;
  color: var(--wm-color-dark);
  margin: 0;
  padding: 5px 0 0;
  font-size: var(--wm-font-md);
  font-weight: var(--wm-font-weight-normal);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
}
wm-track-box .wm-base-box-container .wm-base-box-header .wm-base-box-title::first-letter {
  text-transform: uppercase;
}
wm-track-box .wm-base-box-container .wm-base-box-header .wm-base-box-subtitle-skeleton {
  margin: 15px 0 0;
  height: var(--wm-font-xsm);
  width: 50%;
}
wm-track-box .wm-base-box-container .wm-base-box-header .wm-base-box-title-skeleton {
  margin: 5px 0 0;
  height: var(--wm-font-md);
  width: 70%;
}
wm-track-box .wm-base-box-container .wm-base-box-distance {
  text-align: left;
  color: var(--wm-color-darkgrey);
  height: var(--wm-font-sm);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/box/track-box/track-box.component.scss","webpack://./src/app/shared/wm-core/projects/wm-core/src/theme/mixins.scss"],"names":[],"mappings":"AAEE;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;ECNF,2CAAA;ADMF;AAGI;EACE,cAAA;EACA,cAAA;EACA,0CAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AADN;AAII;EACE,eAAA;EACA,gBAAA;AAFN;AAGM;EACE,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;EACA,wCAAA;AADR;AAGM;EACE,gBAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;EACA,4BAAA;EACA,yCAAA;EAIA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;AAJR;AAJQ;EACE,yBAAA;AAMV;AAIM;EACE,gBAAA;EACA,0BAAA;EACA,UAAA;AAFR;AAIM;EACE,eAAA;EACA,yBAAA;EACA,UAAA;AAFR;AAMI;EACE,gBAAA;EACA,+BAAA;EACA,yBAAA;AAJN","sourcesContent":["@import '../../theme/mixins.scss';\nwm-track-box {\n  .wm-base-box-container {\n    overflow: hidden;\n    width: 225px;\n    height: 185px;\n    border-radius: 15px;\n    margin: 0;\n    @include box-shadow-light;\n\n    .wm-base-box-image-container {\n      display: block;\n      height: 49.95%;\n      background-color: var(--wm-color-skeleton);\n      background-position: center;\n      background-repeat: no-repeat;\n      background-size: cover;\n    }\n\n    .wm-base-box-header {\n      padding: 0 15px;\n      text-align: left;\n      .wm-base-box-subtitle {\n        text-align: left;\n        color: var(--wm-color-primary);\n        text-transform: uppercase;\n        margin: 0;\n        padding: 15px 0 0;\n        font-size: var(--wm-font-xsm);\n        font-weight: var(--wm-font-weight-light);\n      }\n      .wm-base-box-title {\n        text-align: left;\n        color: var(--wm-color-dark);\n        margin: 0;\n        padding: 5px 0 0;\n        font-size: var(--wm-font-md);\n        font-weight: var(--wm-font-weight-normal);\n        &::first-letter {\n          text-transform: uppercase;\n        }\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        /* white-space: nowrap; */\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .wm-base-box-subtitle-skeleton {\n        margin: 15px 0 0;\n        height: var(--wm-font-xsm);\n        width: 50%;\n      }\n      .wm-base-box-title-skeleton {\n        margin: 5px 0 0;\n        height: var(--wm-font-md);\n        width: 70%;\n      }\n    }\n\n    .wm-base-box-distance {\n      text-align: left;\n      color: var(--wm-color-darkgrey);\n      height: var(--wm-font-sm);\n    }\n  }\n}\n","@mixin box-shadow-light {\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);\n}\n\n@mixin box-shadow-dark {\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
